import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextDescriptionEditor = ({ quillRef, value, onChange, modules, formats }) => (
    <div className="form-group mb-4">
        <label htmlFor="post-description" className="form-label">Post Description</label>
        <div className="alert alert-info py-2 px-3 mb-2">
            <small>
                <strong>💡 Tip:</strong> Images larger than 2MB will be automatically compressed when uploaded.
            </small>
        </div>
        <div className="wysiwyg-editor">
            <ReactQuill
                ref={quillRef}
                value={value}
                onChange={onChange}
                theme="snow"
                placeholder="Enter post description with rich formatting..."
                className="description-editor"
                modules={modules}
                formats={formats}
            />
        </div>
    </div>
);

export default RichTextDescriptionEditor;
